"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FuturesBalancesAssetsTable = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Table = require("../../data/table/Table");
var _CryptoNavItemsContainer = _interopRequireDefault(require("../../WalletNavItems/CryptoNavItemsContainer"));
var _FiatNavItemsContainer = _interopRequireDefault(require("../../WalletNavItems/FiatNavItemsContainer"));
var _cssClassesHelper = require("../../../helpers/cssClassesHelper");
var _reactI18next = require("react-i18next");
var _ProductIconContainer = _interopRequireDefault(require("../../common/ProductIcon/ProductIconContainer"));
var _numberFormatter = require("../../../helpers/numberFormatter");
require("./BalancesTable.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var createCls = (0, _cssClassesHelper.getBEMClasses)('wallet-balances-table');
var FuturesBalancesAssetsTable = exports.FuturesBalancesAssetsTable = function FuturesBalancesAssetsTable(_ref) {
  var products = _ref.products,
    loading = _ref.loading,
    baseAsset = _ref.baseAsset;
  var _useTranslation = (0, _reactI18next.useTranslation)('futures'),
    t = _useTranslation.t;
  var renderCell = (0, _react.useCallback)(function (value, notional, product) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: createCls('num-cell')
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: createCls('num-cell__value')
    }, (0, _numberFormatter.formatNumberToLocale)(value, product.DecimalPlaces)), /*#__PURE__*/_react["default"].createElement("span", {
      className: createCls('num-cell__notional')
    }, (0, _numberFormatter.formatNumberToLocale)(notional, product.NotionalDecimalPlaces), /*#__PURE__*/_react["default"].createElement("span", {
      className: createCls('num-cell__symbol')
    }, baseAsset)));
  }, [baseAsset]);
  var columns = (0, _react.useMemo)(function () {
    return [{
      header: t('Actions'),
      id: 'Actions',
      size: 80,
      minSize: 80,
      maxSize: 80,
      meta: {
        textAlign: 'center',
        fixedWidth: true
      },
      className: 'actions',
      cell: function cell(_ref2) {
        var row = _ref2.row;
        var ActionsComponent = row.original.ProductType === 'CryptoCurrency' ? _CryptoNavItemsContainer["default"] : _FiatNavItemsContainer["default"];
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: createCls('actions-inner')
        }, /*#__PURE__*/_react["default"].createElement(ActionsComponent, {
          product: row.original,
          showIconButtonLabel: false,
          margin: true
        }));
      }
    }, {
      header: t('Asset'),
      accessorKey: 'ProductFullName',
      enableSorting: true,
      cell: function cell(_ref3) {
        var row = _ref3.row;
        return /*#__PURE__*/_react["default"].createElement("span", {
          className: createCls('cell-asset')
        }, /*#__PURE__*/_react["default"].createElement(_ProductIconContainer["default"], {
          iconFileName: row.original.iconFileName,
          size: 32
        }), /*#__PURE__*/_react["default"].createElement("span", {
          className: createCls('asset-symbol')
        }, row.original.ProductSymbol), /*#__PURE__*/_react["default"].createElement("span", {
          className: createCls('asset-name')
        }, row.original.ProductFullName));
      }
    }, {
      header: t('Total Balance'),
      accessorKey: 'TotalBalanceNotional',
      enableSorting: true,
      meta: {
        textAlign: 'right'
      },
      cell: function cell(_ref4) {
        var row = _ref4.row,
          getValue = _ref4.getValue;
        return renderCell(row.original.TotalBalance, getValue(), row.original);
      }
    }, {
      header: t('Margin Balance'),
      accessorKey: 'MarginBalanceNotional',
      enableSorting: true,
      meta: {
        textAlign: 'right'
      },
      cell: function cell(_ref5) {
        var row = _ref5.row,
          getValue = _ref5.getValue;
        return renderCell(row.original.MarginBalance, getValue(), row.original);
      }
    }, {
      header: t('Unrealized P&L'),
      accessorKey: 'UnrealizedProfitAndLossNotional',
      enableSorting: true,
      meta: {
        textAlign: 'right'
      },
      cell: function cell(_ref6) {
        var row = _ref6.row,
          getValue = _ref6.getValue;
        return renderCell(row.original.UnrealizedProfitAndLoss, getValue(), row.original);
      }
    }, {
      header: t('Available for Transfer'),
      accessorKey: 'AvailableForTransferNotional',
      enableSorting: true,
      meta: {
        textAlign: 'right'
      },
      cell: function cell(_ref7) {
        var row = _ref7.row,
          getValue = _ref7.getValue;
        return renderCell(row.original.AvailableForTransfer, getValue(), row.original);
      }
    }, {
      header: t('Pending Transfers'),
      accessorKey: 'HoldNotional',
      enableSorting: true,
      meta: {
        textAlign: 'right'
      },
      cell: function cell(_ref8) {
        var row = _ref8.row,
          getValue = _ref8.getValue;
        return renderCell(row.original.Hold, getValue(), row.original);
      }
    }];
  }, [t, renderCell]);
  return /*#__PURE__*/_react["default"].createElement(_Table.Table, {
    data: products,
    columns: columns,
    loading: loading,
    stickyColumns: {
      left: ['Actions', 'ProductFullName']
    },
    className: createCls(),
    emptyMessage: t('No Futures Assets Found')
  });
};
FuturesBalancesAssetsTable.propTypes = {
  products: _propTypes["default"].array,
  loading: _propTypes["default"].bool,
  baseAsset: _propTypes["default"].string
};